import { createAsyncAction, createReducer } from 'typesafe-actions'
import { put, call, takeEvery, all } from 'redux-saga/effects';
import * as api from '../lib/api/subscriptions'
import { AxiosError } from 'axios'
import { subscribeListDTO } from '../lib/api/types';

export const subscribeList = createAsyncAction(
  'REGISTER_SUBSCRIPTION',
  'REGISTER_SUBSCRIPTION_SUCCESS',
  'REGISTER_SUBSCRIPTION_FAILURE',
)<subscribeListDTO, any, AxiosError>();

type subscribeListAction = ReturnType<typeof subscribeList.request>

export type subscribeListPayloadType = {
  code: string
  httpStatusCode: number
  message: string
  customerUid?: string
  merchantUid?: string
  buyerEmail?: string
  buyerName?: string
  buyerTel?: string
}

export type subscribeListState = {
  data: subscribeListPayloadType
  loading: boolean
  error: boolean
  errorData?: AxiosError
  status?: 'request'|'success'|'failure'
}
const initialState: subscribeListState = {
  data: {
    code:'',
    httpStatusCode:0,
    message:''
  },
  loading:false,
  error:false,
}

function* subscribeListSaga(action:subscribeListAction):Generator{
  try {
    const response:any = yield call(
      api.subscribeList,
      action.payload
    )
    yield put(subscribeList.success(response.data))
  } catch (e) {
    yield put(subscribeList.failure(e))
  }
}

export function* subscribeListsSaga(){
  yield all([takeEvery(subscribeList.request, subscribeListSaga)])
}

export const subscribeListInfo = createReducer<
  subscribeListState,
  ReturnType<typeof subscribeList.request>|
  ReturnType<typeof subscribeList.success>|
  ReturnType<typeof subscribeList.failure>
>(initialState)
  .handleAction(
    subscribeList.request,
  (state:subscribeListState, action:{payload:subscribeListDTO}
    )=>({
      ...state,
      loading:true,
      error:false,
      status:'request',
    })
  )
  .handleAction(
    subscribeList.success,
    (state:subscribeListState, action:{payload:subscribeListPayloadType})=>({
      ...state,
      loading:false,
      error:false,
      status:'success',
      data:action.payload
    })
  )
  .handleAction(
    subscribeList.failure,
    (state:subscribeListState,action:{payload:AxiosError})=>({
      ...state,
      loading:false,
      data:{
        code:'',
        httpStatusCode:0,
        message:''
      },
      error:true,
      status:'failure',
      errorData:action.payload
    })
  )

  export default subscribeListInfo